module.exports = __webpack_public_path__ + "static/media/46_A.074f8ec0.png";